<template>
  <w-sliding-popup type="setting" ref="slidingPopup" title="적용 템플릿 수정" width="1200px" @close="close()">
    <div slot="content">
      <el-row type="flex" :gutter="15">
        <el-col :span="12">
          <w-template-list-table ref="templateListTable" :target-tmpl-list="targetTmplList"/>
        </el-col>
        <el-col :span="12">
          <w-target-template-list-table ref="targetTemplateListTable" :target-tmpl-list="targetTmplList" :origin-tmpl-target-ids="originTargetTmplIds"
          @reload-obj-list="reloadObjList"/>
        </el-col>
      </el-row>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="clickClose">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { cloneDeep, isEqual, isNil, difference } from 'lodash';
import { stringify } from 'querystring';
import msgUtil from '@/utils/message';
import WSearchField from '@/components/form/SearchField';
import VirtualServiceSettingAPI from '@/api/settings/virtual/virtual-service-settings';
import WTemplateListTable from './components/TemplateListTable';
import WTargetTemplateListTable from './components/TargetTemplateListTable';

export default {
  name: 'WTargetTemplateSettingPopup',
  components: {
    WSearchField,
    WTemplateListTable,
    WTargetTemplateListTable,
  },
  props: {
    selectedImage: Object,
    targetTmplList: Array,
    originTargetTmplIds: Array,
  },
  data() {
    return {
      isloaded: false,
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
      this.loadData();
    },
    close() {
      this.initData();
    },
    onSaveButton() {
      const targetTmplIds = [];
      this.targetTmplList.forEach((tmpl) => {
        if (!targetTmplIds.includes(tmpl.vmsObjId)) {
          targetTmplIds.push(tmpl.vmsObjId);
        }
      });
      targetTmplIds.sort((a, b) => (a - b));

      const insertVmsObjIds = difference(targetTmplIds, this.originTargetTmplIds);
      const deleteVmsObjIds = difference(this.originTargetTmplIds, targetTmplIds);
      const vmsImageObjList = [];
      const target = '적용 템플릿';
      const action = msgUtil.action.SAVE;
      insertVmsObjIds.forEach((vmsObjId) => {
        vmsImageObjList.push({
          vmsObjId,
          imageId: this.selectedImage.imageId,
          sql_type: 'INSERT',
        });
      });
      deleteVmsObjIds.forEach((vmsObjId) => {
        vmsImageObjList.push({
          vmsObjId,
          imageId: this.selectedImage.imageId,
          sql_type: 'DELETE',
        });
      });
      VirtualServiceSettingAPI.updateVmsImageObjList(vmsImageObjList).then((response) => {
        const result = response.data;
        if (result.success === true) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.$emit('reload-data');
          this.clickClose();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    clickClose() {
      this.$refs.slidingPopup.close();
    },
    initData() {
      this.$refs.templateListTable.initData();
      // this.$refs.selectedObjTable.initData();
    },
    loadData() {
      this.$nextTick(() => {
        this.$refs.templateListTable.loadData();
      });
    },
    reloadObjList() {
      this.$refs.templateListTable.setCheckTemplateTable();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/VirtualService/ServerImageSetting/popup/TargetTemplateSettingPopup.vue